// extracted by mini-css-extract-plugin
export default {"wrapperClassName":"DynamicField_wrapperClassName__lC3Da","labelClassName":"DynamicField_labelClassName__sPzoG"};